<form *ngIf="form" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="ui-g-12">
    <span class="label required">MS Base Url</span>
    <input pInputText type="text" formControlName="msBaseUrl" class="p-inputtext-lg" />
    <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['msBaseUrl'].errors?.required">{{ 'common.required_error' | translate }}</span>
  </div>
  <div class="ui-g-12 text-center">
    <button
      class="k-generic-btn"
      pButton
      icon="fa fa-check"
      label="{{ 'common.save' |translate }}"
      (click)="save()">
    </button>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/associations-management/associations/association-msbaseurl-form/association-msbaseurl-form.component.html